<template>
  <a class="tab-bar-item"
     @click="handleClick"
  >
    <slot></slot>
  </a>
</template>

<script>
  export default {
    name: 'YmTabbarItem',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        if (!this.disabled) {
          this.$emit('click');
        }
      },
    },
  };
</script>
